import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    scroller: {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'auto',
    },
    content: { position: 'relative' },
    item: { position: 'absolute', boxSizing: 'border-box' },
  },
  { name: 'masonry-grid' },
);

export default useStyles;
